import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getLegalitasContent = createAsyncThunk('/legalitas/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listLegality/${userId}`, {})
    return response.data;
})

export const legalitasSlice = createSlice({
    name: 'legalitas',
    initialState: {
        isLoading: false,
        legalitas : []
    },
    reducers: {


        addNewLegalitas: (state, action) => {
            let {newLegalitasObj} = action.payload
            state.legalitas = [...state.legalitas, newLegalitasObj]
        },

        deleteLegalitas: (state, action) => {
            let {index} = action.payload
            state.legalitas.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getLegalitasContent.pending]: state => {
			state.isLoading = true
		},
        [getLegalitasContent.fulfilled]: (state, action) => {
            state.legalitas = action.payload.data
			state.isLoading = false
		},
        [getLegalitasContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {           
        builder
        .addCase(getLegalitasContent.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getLegalitasContent.fulfilled, (state, action) => {
            state.legalitas = action.payload.data;
            state.isLoading = false;
        })
        .addCase(getLegalitasContent.rejected, (state) => {
            state.isLoading = false;
        });
    }
})

export const { addNewLegalitas, deleteLegalitas } = legalitasSlice.actions

export default legalitasSlice.reducer